export const appAds = {
  AppsPerformanceReport: {
    mandatory: [],
    default: [
      'AccountName',
      'CampaignName',
      'CampaignId',
      'AssetGroupName',
      'Impressions',
      'Clicks',
      'CTR',
      'Spend',
      'Downloads',
      'PostClickDownloadRate',
      'CostPerDownload',
      'AppInstalls',
      'PostClickInstallRate',
      'CPI',
      'Purchases',
      'PostInstallPurchaseRate',
      'CPP',
      'Subscriptions',
      'PostInstallSubscriptionRate',
      'CPS',
      'Revenue',
      'ReturnOnAdSpend',
      'RevenuePerDownload',
      'RevenuePerAppInstall',
    ],
  },
};

